/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_layers__header = /** @type {(inputs: {}) => string} */ () => {
	return `Kartentyp`
};

const en_layers__header = /** @type {(inputs: {}) => string} */ () => {
	return `Your map appearance`
};

const es_layers__header = /** @type {(inputs: {}) => string} */ () => {
	return `Apariencia de tu mapa`
};

const fr_layers__header = /** @type {(inputs: {}) => string} */ () => {
	return `Apparence de votre carte`
};

const it_layers__header = /** @type {(inputs: {}) => string} */ () => {
	return `Aspetto della mappa`
};

const nl_layers__header = /** @type {(inputs: {}) => string} */ () => {
	return `Uiterlijk van uw kaart`
};

const pt_layers__header = /** @type {(inputs: {}) => string} */ () => {
	return `Aspeto do seu mapa`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const layers__header = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.layers__header(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("layers__header", locale)
	if (locale === "de") return de_layers__header(inputs)
	if (locale === "en") return en_layers__header(inputs)
	if (locale === "es") return es_layers__header(inputs)
	if (locale === "fr") return fr_layers__header(inputs)
	if (locale === "it") return it_layers__header(inputs)
	if (locale === "nl") return nl_layers__header(inputs)
	return pt_layers__header(inputs)
};